module.exports = __webpack_public_path__ + "img/コンピュータのしくみI_4_3_3.0a65887e.jpeg";